import { render } from "./IconButton.vue?vue&type=template&id=282c1620&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=282c1620&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282c1620"],['__file',"src/scripts/common/components/IconButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282c1620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282c1620', __exports__)) {
    api.reload('282c1620', __exports__)
  }
  
  module.hot.accept("./IconButton.vue?vue&type=template&id=282c1620&scoped=true", () => {
    api.rerender('282c1620', render)
  })

}


export default __exports__